var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilmStrip = function SvgIconFilmStrip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 20.5A1.75 1.75 0 0 1 2 18.75V5.25c0-.966.784-1.75 1.75-1.75h16.5c.966 0 1.75.784 1.75 1.75v13.5a1.75 1.75 0 0 1-1.75 1.75zM4 14.75v-5.5h7v5.5zm0 2h2.5v1.75H4zm4.5 0v1.75H11v-1.75zm9 1.75H20v-1.75h-2.5zm-2-1.75v1.75H13v-1.75zm4.5-2v-5.5h-7v5.5zm-9-7.5H8.5V5.5H11zm-4.5 0V5.5H4v1.75zm9-1.75H13v1.75h2.5zm2 1.75V5.5H20v1.75z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFilmStrip;